import { createBrowserHistory } from "history";
import { enableMapSet } from "immer";
import configureStore from "../store/configureStore";

// Setup dayjs plugins once
import "./setupDayjs";

/** Initial store setup and more, used in index.tsx and for micro frontend wrapper component(s) */
export function initialSetup() {
    enableMapSet();

    // Create browser history to use in the Redux store
    const history = createBrowserHistory();

    // Get the application-wide store instance, prepopulating with state from the server where available.
    const store = configureStore(history);

    return { history, store };
}
